'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useState } from 'react'

// lib
import { EyeIcon, EyeBackslashIcon } from '../../icons'
import TextField, { TextFieldProps } from './text-field'

/* -----------------------------------------------------------------------------
 * PasswordField
 * -------------------------------------------------------------------------- */

export type PasswordFieldProps = Omit<TextFieldProps, 'label'> & {
  label?: TextFieldProps['label']
}

const PasswordField = ({ required, ...props }: PasswordFieldProps) => {
  const requiredVal =
    required && typeof required === 'boolean'
      ? 'Please enter your password'
      : required
  const [isSecure, setIsSecure] = useState(true)
  const changeVisibility = () => {
    setIsSecure(!isSecure)
  }

  return (
    <React.Fragment>
      <TextField
        label='Password'
        required={requiredVal}
        secureTextEntry={isSecure}
        autoCompleteType='password'
        textContentType='password'
        fieldIcon={isSecure ? <EyeIcon /> : <EyeBackslashIcon />}
        onIconPress={changeVisibility}
        {...props}
      />
    </React.Fragment>
  )
}

export default PasswordField
